import {
  updateHtzWorkOrderCache,
  useHtzWorkOrderPatchMutation,
  useHtzWorkOrderResetReferenceNumberMutation,
  useHtzWorkOrderShowQuery,
} from "@/services/backend/htz/work-order/api/work-order-api";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";

/**
 * WorkOrderReferenceNumberField renders the reference number from the RTK
 * Query cache, independent of the local work order buffer of the card. Hidden
 * for the work order of a commitment, which never has a reference number. A
 * work order without a number yet shows the empty field, so the generated
 * number can be taken over.
 */
export function WorkOrderReferenceNumberField({
  workOrderId,
}: {
  workOrderId: string;
}) {
  const { data } = useHtzWorkOrderShowQuery({ id: workOrderId });
  const patchReferenceNumber = useHtzWorkOrderPatchMutation();
  const resetReferenceNumber = useHtzWorkOrderResetReferenceNumberMutation();

  if (!data || data.commitmentId) {
    return null;
  }

  return (
    <ReferenceNumberField
      data={data}
      updateCache={updateHtzWorkOrderCache}
      patchMutation={patchReferenceNumber}
      resetMutation={resetReferenceNumber}
      disabled={isImmutable(data)}
    />
  );
}
